<template>
    <div ref="container" class="block-work-with-us" >
        <!-- Panel 2 -->
        <div class="panel-2 sethmob">
            <div class="flx under" :style="`background-image:url('${window.config.json.artifacts.workWithUsMaskBg}')`">
                <div
                    class="bgimg parallax-hook"
                    :style="`background-image:url('${window.config.json.artifacts.generalBg}')`"
                ></div>
                <div class="flx2">
                    <img alt="" aria-hidden="true" class="line-top" :src="window.config.json.artifacts.workWithUsLineTop" />
                    <h4 v-if="json.keepScrolling" v-html="json.keepScrolling"></h4>
                    <div class="text-mask-container">
                        <h2 v-if="json.startingTitle" v-html="gh.nl2br(json.startingTitle)" ></h2>
                    </div>
                    <div class="caption" v-if="json.caption" v-html="json.caption"></div>
                    <h3 v-if="json.learnMore">
                        <router-link to="/careers" aria-label="Careers" >
                            <span v-html="json.learnMore"></span>
                            <CaretRight />
                        </router-link>
                    </h3>
                    <img alt="" aria-hidden="true" class="line-bottom" :src="window.config.json.artifacts.workWithUsLineBottom" />
                </div>
            </div>
            <div ref="over" class="flx over" :class="{ visible: isOverVisible }">
                <div class="flx2">
                    <img alt="" aria-hidden="true" class="line-top" :src="window.config.json.artifacts.workWithUsLineTop" />
                    <h4 v-if="json.keepScrolling" v-html="json.keepScrolling"></h4>
                    <div class="text-mask-container">
                        <h2
                            v-if="json.startingTitle"
                            v-html="gh.nl2br(json.startingTitle)"
                            class="masked-text"
                            :style="`background-image:url('${window.config.json.artifacts.workWithUsMaskBg}')`"
                        ></h2>
                    </div>
                    <div class="caption" v-if="json.caption" v-html="json.caption"></div>
                    <h3 v-if="json.learnMore">
                        <router-link to="/careers" aria-label="Careers" >
                            <span v-html="json.learnMore"></span>
                            <CaretRight />
                        </router-link>
                    </h3>
                    <img  alt="" aria-hidden="true" class="line-bottom" :src="window.config.json.artifacts.workWithUsLineBottom" />
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import gh from '@/helpers/gh'
import CaretRight from "@/components/svgs/CaretRight.vue";
export default {
    name: "WorkWithUs",
    components: {CaretRight },
    props: {
        json: {
            type: Object,
            required: true,
            default: null,
        },
    },
    data() {
        return {
            window: window,
            gh: gh,
            isOverVisible: false,
            hasBottomPassed: false,
        };
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('scroll', this.checkVisibility, { passive: true });
            this.checkVisibility(); // initial
        });
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.checkVisibility);
    },
    methods: {
        checkVisibility() {
            const over = this.$refs.over;
            if (!over) return;

            const rect = over.getBoundingClientRect();
            const windowHeight = window.innerHeight || document.documentElement.clientHeight;
            const elementHeight = rect.height;

            // If bottom is on screen or above
            if (rect.bottom <= windowHeight) {
                this.isOverVisible = true;
                this.hasBottomPassed = true;
            } else {
                this.hasBottomPassed = false;
            }

            if (this.hasBottomPassed) {
                this.isOverVisible = true
            } else  {
                const visibleHeight = Math.min(windowHeight, rect.bottom) - Math.max(0, rect.top);
                const visibleRatio = visibleHeight / elementHeight;

                if (visibleRatio >= 0.75) {
                    this.isOverVisible = true;
                } else {
                    this.isOverVisible = false;
                }
            }
        },
    },
};
</script>


